module.exports = __webpack_public_path__ + "components/rewards/sixt/static/logo-ad044acf2ddb99de37b5bbf6e079c890.webp";